import { useEffect, useState } from 'react'
import React from 'react'
import { Container, Card, Row, Col, Button, Modal, Form } from 'react-bootstrap'
import { FaUserCircle, FaArrowLeft, FaBus, FaExclamationCircle } from 'react-icons/fa'
import { BsJournalBookmark, BsArrowClockwise, BsChevronDown, BsChevronUp } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import { useNavigate, useParams } from 'react-router-dom'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import axios from 'axios'
import { useSidebar } from './SidebarContext'
import { useAuth } from './AuthContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { mapParentAssignedTransports, studentHasAssignedBus } from '../utils/parentTransport'

const pickRollNumber = (...values) => {
  for (const value of values) {
    if (value !== null && value !== undefined && String(value).trim() !== '') {
      return String(value).trim()
    }
  }
  return ''
}

const fetchEnrollmentRollNumber = async (studentId, classId, authToken) => {
  if (!studentId || !classId) return ''
  try {
    const response = await axios.get(BASE_URL + '/get/student/all/enroll', {
      params: { student_id: studentId },
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
    })
    const enrollments = Array.isArray(response?.data?.data)
      ? response.data.data
      : []
    const classMatch = enrollments.find(
      (row) => Number(row.class_id) === Number(classId),
    )
    const fallback = enrollments[0]
    return pickRollNumber(
      classMatch?.roll_number,
      classMatch?.roll_no,
      fallback?.roll_number,
      fallback?.roll_no,
    )
  } catch {
    return ''
  }
}

const ViewStudent = ({ student }) => {
  const { isCollapsed } = useSidebar()
  const { logout } = useAuth()
  const [logoError, setLogoError] = useState(false)
  const { logo } = useInstitute()

  const [marginLeft, setMarginLeft] = useState('0px')

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const { id } = useParams()
  console.log('id:', id)
  const [data, setData] = useState('')
  console.log('data is define here', data)
  const navigate = useNavigate()

  const [studentData, setStudentData] = useState(null)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState([])
  const [opentDateModal, setOpenDateModal] = useState(false)
  const [highlightUpdate, setHighlightUpdate] = useState(false)
  const [leavingDate, setLeavingDate] = useState('')
  const [showAssignedTransport, setShowAssignedTransport] = useState(
    typeof window !== 'undefined' ? window.innerWidth > 768 : true,
  )
  const [assignedTransports, setAssignedTransports] = useState([])
  const [assignedTransportError, setAssignedTransportError] = useState('')
  const [loadingAssignedTransport, setLoadingAssignedTransport] = useState(false)
  const [loadingTransportRefresh, setLoadingTransportRefresh] = useState(false)

  useEffect(() => {
    const storedInstitute =
      Cookies.get('institute_name') || Cookies.get('name') || ''

    if (storedInstitute) {
      setInstitutes([{ name: storedInstitute }])
    }
  }, [])
  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
   
    const fetchAllClasses = async()=>{
      try {
       const institute_id = Cookies.get('institute_id')

        const headers = {
          institute_id : institute_id
        }
        const res = await axios.get(BASE_URL + "/class/all", {headers})
        setClasses(res.data.data)
      } catch (error) {
        console.error(error.response.data)
      }
    }
    fetchAllClasses()
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllInstitutes().then((res) => {
      if (Array.isArray(res.data.data)) {
        setInstitutes(res.data.data)
      } else {
        setInstitutes([]) // Fallback to empty array
      }
    })
  }, [])

  const [img, setImg] = useState(null)
  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const response = await ApiEndpoints.viewProfile(id)
        console.log('Response of viewProfile: ', response.data.data)
        let profileData = response.data.data

        const existingRoll = pickRollNumber(
          profileData?.roll_number,
          profileData?.roll_no,
          profileData?.rollNumber,
        )
        if (!existingRoll && profileData?.class_id) {
          const userCookie = Cookies.get('user')
          const token = userCookie ? JSON.parse(userCookie)?.token : null
          const rollNumber = await fetchEnrollmentRollNumber(
            id,
            profileData.class_id,
            token,
          )
          if (rollNumber) {
            profileData = { ...profileData, roll_number: rollNumber }
          }
        }

        setData(profileData)
        setStudentData(profileData)
        setImg(profileData)
      } catch (error) {
        error(error.response?.data?.message || 'Something wents worng.')
      }
    }
    if (id) fetchStudentData()
  }, [id])

  const fetchAssignedTransport = async (profileOverride = null) => {
    if (!id) {
      setAssignedTransports([])
      setAssignedTransportError('')
      return false
    }

    setLoadingAssignedTransport(true)
    try {
      const profile =
        profileOverride && typeof profileOverride === 'object'
          ? profileOverride
          : studentData && typeof studentData === 'object'
            ? studentData
            : data && typeof data === 'object'
              ? data
              : null

      if (studentHasAssignedBus(profile) === false) {
        setAssignedTransports([])
        setAssignedTransportError('')
        return false
      }

      const response = await ApiEndpoints.getChildBus()
      const mapped = mapParentAssignedTransports(response?.data, id, profile)
      setAssignedTransports(mapped)
      setAssignedTransportError('')
      return true
    } catch (error) {
      setAssignedTransports([])
      setAssignedTransportError(
        error.response?.data?.message || 'Unable to load assigned transport.',
      )
      return false
    } finally {
      setLoadingAssignedTransport(false)
    }
  }

  useEffect(() => {
    if (!id || !data?.id) {
      if (!id) {
        setAssignedTransports([])
        setAssignedTransportError('')
      }
      return
    }
    fetchAssignedTransport(data)
  }, [id, data?.id, data?.assign_bus, data?.pickup, data?.pick_up])

  const refreshAssignedTransport = async () => {
    setLoadingTransportRefresh(true)
    try {
      const ok = await fetchAssignedTransport()
      if (ok) toast.success('Transport details refreshed.')
    } finally {
      setLoadingTransportRefresh(false)
    }
  }

  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  const handleBack = () => {
    navigate('/parent/student/list')
  }

  const handleIdCard = () => {
    navigate(`/student/id-card/${id}`)
  }
  const handleUpdateStudentProfile = () => {
    // setHighlightUpdate(true)

    // setTimeout(() => setHighlightUpdate(false), 3000)
    navigate(`/student/update-profile/${id}`)
  }
  const handleViewFees = (id, course_id, class_id) => {
    // navigate(`/student/fees/${id}/${course_id}/${class_id}`)
    navigate(`/parent/student/fees/${id}`)
    console.log('Student ID:', id)
    console.log('Course ID:', course_id)
    console.log('Class ID:', class_id)
  }

  const handleViewCourse = () => {
    const studentName = studentData?.name
    const admissionNumber = studentData?.admission_number

    navigate(`/student/enrolled-courses/${id}`, {
      state: {
        student_id: id,
        student_name: studentName,
        admission_number: admissionNumber,
      },
    })
    console.log('EnrolledCourses', id)
    console.log('studentName', studentName)
  }
  const handleViewAttendance = (id, course_id, class_id) => {
    if (!course_id || !class_id) {
      toast.error('Please add course and class first.')
      setHighlightUpdate(true)
      setTimeout(() => setHighlightUpdate(false), 5000)
    } else {
      navigate(`/parent/student/attendance/${id}/${course_id}/${class_id}`)
      console.log('Student ID:', id)
      console.log('Course ID:', course_id)
      console.log('Class ID:', class_id)
    }
  }
  const handleDischarge = () => {
    setOpenDateModal(true)
    // navigate('/student/discharged')
  }
  // const handleViewResult = () => {
  // navigate(`/student/id-card/${id}`)
  // }

  const handleDischargeNow = async (e) => {
    e.preventDefault()
    if (!leavingDate) {
      toast.error('Please select a leaving date.')
      return
    }
    const userCookie = Cookies.get('user')
    if (!userCookie) {
      toast.error('User not authenticated. Please log in.')
      return
    }

    try {
      const status = 'inactive'

      const user = JSON.parse(userCookie)
      let token = user.token

      const response = await axios.post(
        BASE_URL+`/students/${id}/status?status=${status}&leaving_date=${leavingDate}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      toast.success(response.data.message)
      navigate('/student/discharged')
    } catch (error) {
      console.error(error.response?.data?.message)
    }
  }

  const handleViewMarksheet = (id, course_id, class_id)=>{
    if (!course_id || !class_id) {
      toast.error('Please add course and class first.')
      setHighlightUpdate(true)
      setTimeout(() => setHighlightUpdate(false), 5000)
    } else {
      navigate(`/ExamMarksheet/${id}/${course_id}/${class_id}`)
      console.log('Student ID:', id)
      console.log('Course ID:', course_id)
      console.log('Class ID:', class_id)
    }
  }

  const handleViewHomework = (studentId) => {
    navigate(`/parent/student/profile/${studentId}/homework`, {
      state: { fromParentStudentProfile: true },
    })
  }

  return (
    <>
      <style>
        {`
          .info-label {
            font-size: 12px;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 6px;
            font-family: Inter, system-ui, sans-serif;
          }
          .info-value {
            font-size: 15px;
            font-weight: 500;
            color: #111827;
            font-family: Inter, system-ui, sans-serif;
            margin-bottom: 0px;
          }
          .action-button {
            transition: all 0.2s ease;
          }
          .action-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
          .blink-updateButton {
          animation: blink 0.5s linear infinite;
          border: 2px solid #ff9900 !important;
        }

        @keyframes blink {
          50% {
            opacity: 0.5;
          }
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        `}
      </style>

      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '62px' : '12px',
          paddingRight: isCollapsed ? '62px' : '12px',
        }}
      >
        {data ? (
          <>
            <div
              className="container-fluid p-0"
              style={{
                marginTop: window.innerWidth < 992 ? '55px' : '-12px',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    background: '#F3F4F6',
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    overflow: 'visible',
                    borderBottom: '1px solid #D1D3D4',
                    // width: '100%',
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-3"
                    style={{ flex: 1 }}
                  >
                    <div
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        background: '#223843',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {!logoError ? (
                        <img
                          src={logo}
                          alt="School Logo"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                          onError={() => setLogoError(true)}
                        />
                      ) : (
                        <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                      )}
                    </div>

                    <div>
                      <h3
                        className="m-0 fw-bold text-start"
                        style={{
                          letterSpacing: '-0.02em',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          fontSize: 'clamp(18px, 2.5vw, 22px)',
                          color: '#223843',
                          lineHeight: '1.2',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {data?.name
                          ? data.name.charAt(0).toUpperCase() +
                            data.name.slice(1).toLowerCase()
                          : 'Your child'}
                      </h3>
                      <p
                        className="m-0 mt-1 text-start"
                        style={{
                          fontSize: window.innerWidth < 768 ? '11px' : '13px',
                          color: '#6b7280',
                          fontWeight: '400',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Your child's profile
                      </p>
                    </div>
                  </div>

                  {!isMobile && <ProfileDropdown logout={logout} />}
                </div>
              </div>
            </div>
            <Container
              className="mt-4"
              style={{
                paddingLeft: window.innerWidth < 768 ? '16px' : '40px',
                paddingRight: window.innerWidth < 768 ? '16px' : '32px',
                paddingTop: '32px',
                paddingBottom: '32px',
                maxWidth: '100%',
              }}
            >
              <Row className="mb-4">
                <Col xs={12} md={8} className="mb-3 mb-md-0">
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow:
                        '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      height: '100%',
                    }}
                  >
                    <Card.Body style={{ padding: '40px', textAlign: 'center' }}>
                      <div
                        className="mb-4"
                        style={{ position: 'relative', display: 'inline-block' }}
                      >
                        {img?.student_image ? (
                          <div
                            style={{
                              width: '140px',
                              height: '140px',
                              borderRadius: '50%',
                              border: '4px solid #223843',
                              overflow: 'visible',
                              background: '#ffffff',
                              display: 'inline-block',
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                              position: 'relative',
                            }}
                          >
                            <img
                              src={img.student_image}
                              alt="Profile"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '50%',
                              }}
                            />
                            <button
                              onClick={handleBack}
                              style={{
                                position: 'absolute',
                                bottom: '-8px',
                                right: '-8px',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#223843',
                                border: '3px solid #ffffff',
                                color: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                zIndex: 10,
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.1)'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)'
                              }}
                              title="Back to your children"
                            >
                              <FaArrowLeft size={16} />
                            </button>
                          </div>
                        ) : (
                          <div
                            style={{
                              width: '140px',
                              height: '140px',
                              borderRadius: '50%',
                              border: '4px solid #223843',
                              background: '#F3F4F6',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                              position: 'relative',
                            }}
                          >
                            <FaUserCircle size={64} style={{ color: '#9ca3af' }} />
                            <button
                              onClick={handleBack}
                              style={{
                                position: 'absolute',
                                bottom: '-8px',
                                right: '-8px',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#223843',
                                border: '3px solid #ffffff',
                                color: '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                boxShadow: '0 2px 4px rgba(0, 0, 0,  0.2)',
                                zIndex: 10,
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.1)'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)'
                              }}
                              title="Back to your children"
                            >
                              <FaArrowLeft size={16} />
                            </button>
                          </div>
                        )}
                      </div>

                      <h2
                        className="text-uppercase"
                        style={{
                          color: '#111827',
                          fontWeight: '700',
                          fontSize: 'clamp(24px, 3vw, 32px)',
                          marginBottom: '12px',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {data?.name
                          ? data.name.charAt(0).toUpperCase() +
                            data.name.slice(1).toLowerCase()
                          : 'N/A'}
                      </h2>

                      <p
                        style={{
                          color: '#6b7280',
                          fontSize: '16px',
                          marginBottom: '18px',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        {data?.email || data?.admission_number || 'N/A'}
                      </p>

                      <div className="d-flex flex-wrap justify-content-center gap-2">
                        <span
                          style={{
                            backgroundColor: '#EFF6FF',
                            color: '#223843',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '600',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          {data?.admission_number || 'N/A'}
                        </span>

                        <span
                          style={{
                            backgroundColor: '#F0F9FF',
                            color: '#223843',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '600',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          Roll:{' '}
                          {pickRollNumber(
                            data?.roll_number,
                            data?.roll_no,
                            data?.rollNumber,
                          ) || 'N/A'}
                        </span>

                        <span
                          style={{
                            backgroundColor:
                              data?.status === 'active' ? '#ECFDF5' : '#FEE2E2',
                            color: data?.status === 'active' ? '#10B981' : '#EF4444',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '600',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          {data?.status
                            ? data.status.charAt(0).toUpperCase() + data.status.slice(1)
                            : 'N/A'}
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={12} md={4}>
                  <Card
                    style={{
                      border: '1px solid #D1D3D4',
                      borderRadius: '16px',
                      boxShadow:
                        '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      height: '100%',
                    }}
                  >
                    <Card.Body style={{ padding: '24px' }}>
                      <h5
                        style={{
                          fontWeight: '700',
                          marginBottom: '14px',
                          color: '#223843',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        For your child
                      </h5>
                      <p
                        className="text-start text-muted small mb-3"
                        style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
                      >
                        Quick access to your child&apos;s records
                      </p>

                      <Row className="g-3">
                        <Col xs={6}>
                          <Button
                            variant="light"
                            onClick={() =>
                              handleViewFees(data.id, data.course_id, data.class_id)
                            }
                            className="w-100 action-button"
                            style={{
                              backgroundColor: '#DBEAFE',
                              border: '1px solid #BFDBFE',
                              color: '#223843',
                              borderRadius: '10px',
                              padding: '14px 10px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              fontWeight: '700',
                              minHeight: '64px',
                            }}
                          >
                            Fees
                          </Button>
                        </Col>
                        <Col xs={6}>
                          <Button
                            variant="light"
                            onClick={() =>
                              handleViewAttendance(
                                data.id,
                                data.course_id,
                                data.class_id,
                              )
                            }
                            className={`w-100 action-button ${
                              highlightUpdate ? 'blink-updateButton' : ''
                            }`}
                            style={{
                              backgroundColor: '#FEF3C7',
                              border: '1px solid #FDE68A',
                              color: '#92400E',
                              borderRadius: '10px',
                              padding: '14px 10px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              fontWeight: '700',
                              minHeight: '64px',
                            }}
                          >
                            Attendance
                          </Button>
                        </Col>
                        <Col xs={12}>
                          <Button
                            variant="light"
                            onClick={() => handleViewHomework(data.id)}
                            className="w-100 action-button"
                            style={{
                              backgroundColor: '#FFF7ED',
                              border: '1px solid #FFEDD5',
                              color: '#EA580C',
                              borderRadius: '10px',
                              padding: '14px 10px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              fontWeight: '700',
                              minHeight: '64px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px',
                            }}
                          >
                            <BsJournalBookmark size={18} />
                            View Homework
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Card
                className="mb-4"
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '16px',
                  boxShadow:
                    '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                }}
              >
                <Card.Body style={{ padding: '24px' }}>
                  <h5
                    style={{
                      fontWeight: '700',
                      marginBottom: '18px',
                      color: '#223843',
                      fontFamily: 'Inter, system-ui, sans-serif',
                    }}
                  >
                    About your child
                  </h5>

                  <Row className="g-3">
                    {[
                      { label: 'Institute Name', value: institutes?.find((insti) => insti.institute_id === data?.institute_id)?.name || institutes?.find((insti) => insti.id === data?.institute_id)?.name || Cookies.get('institute_name') || 'N/A' },
                      { label: 'Admission Number', value: data?.admission_number || 'N/A' },
                      {
                        label: 'Roll Number',
                        value:
                          pickRollNumber(
                            data?.roll_number,
                            data?.roll_no,
                            data?.rollNumber,
                          ) || 'N/A',
                      },
                      { label: 'Admission Date', value: data?.admission_date || 'N/A' },
                      { label: 'Email Address', value: data?.email || 'N/A' },
                      { label: 'Gender', value: data?.gender || 'N/A' },
                      { label: 'Birth Date', value: data?.dob || 'N/A' },
                      { label: 'Age', value: calculateAge(data?.dob) || 'N/A' },
                      { label: 'Address', value: data?.address || 'N/A' },
                      { label: 'ID Proof Number', value: data?.id_proof_number || 'N/A' },
                      { label: "Father's Name", value: data?.father_name || 'N/A' },
                      { label: "Mother's Name", value: data?.mother_name || 'N/A' },
                      { label: 'Phone Number', value: data?.phone || 'N/A' },
                      { label: "Parent's Number", value: data?.parents_number || 'N/A' },
                      { label: 'WhatsApp Number', value: data?.whatsapp_number || 'N/A' },
                    ].map((item) => (
                      <Col key={item.label} md={3} xs={6}>
                        <div
                          className="h-100"
                          style={{
                            border: '1px solid #E5E7EB',
                            borderRadius: '12px',
                            padding: '14px',
                            background: '#ffffff',
                          }}
                        >
                          <div className="info-label">{item.label}</div>
                          <div className="info-value">{item.value}</div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>

              <Card
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '16px',
                  boxShadow:
                    '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    background: 'linear-gradient(135deg, #B45309 0%, #92400E 100%)',
                    padding: '16px 24px',
                    borderBottom: '1px solid #D1D3D4',
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <FaBus size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <div>
                        <h5
                          className="text-start"
                          style={{
                            margin: 0,
                            fontWeight: '700',
                            color: '#ffffff',
                            fontSize: '18px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          School transport
                        </h5>
                        <p
                          style={{
                            margin: '2px 0 0 0',
                            color: 'rgba(255, 255, 255, 0.9)',
                            fontSize: '12px',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          Transport details for your child
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowAssignedTransport(!showAssignedTransport)}
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        border: 'none',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'
                        e.currentTarget.style.transform = 'scale(1.1)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'
                        e.currentTarget.style.transform = 'scale(1)'
                      }}
                      title={showAssignedTransport ? 'Hide Section' : 'Show Section'}
                    >
                      {showAssignedTransport ? <BsChevronUp size={18} /> : <BsChevronDown size={18} />}
                    </button>
                  </div>
                </div>

                {showAssignedTransport && (
                  <Card.Body style={{ padding: '20px' }}>
                    <div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '8px',
                              backgroundColor: '#FFEDD5',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <FaBus size={16} style={{ color: '#B45309' }} />
                          </div>
                          <h6
                            style={{
                              margin: 0,
                              fontWeight: '600',
                              color: '#111827',
                              fontSize: '14px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            Routes for your child ({assignedTransports.length})
                          </h6>
                        </div>
                        <button
                          type="button"
                          onClick={refreshAssignedTransport}
                          disabled={loadingTransportRefresh || loadingAssignedTransport}
                          style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            backgroundColor: '#B45309',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor:
                              loadingTransportRefresh || loadingAssignedTransport
                                ? 'not-allowed'
                                : 'pointer',
                            transition: 'all 0.2s ease',
                            opacity: loadingTransportRefresh || loadingAssignedTransport ? 0.7 : 1,
                          }}
                          title="Refresh list"
                        >
                          <BsArrowClockwise
                            size={20}
                            style={{
                              animation:
                                loadingTransportRefresh || loadingAssignedTransport
                                  ? 'spin 1s linear infinite'
                                  : 'none',
                            }}
                          />
                        </button>
                      </div>

                      {loadingTransportRefresh || loadingAssignedTransport ? (
                        <div
                          className="text-center py-4"
                          style={{
                            backgroundColor: '#F9FAFB',
                            borderRadius: '8px',
                            padding: '32px',
                            border: '1px solid #E5E7EB',
                          }}
                        >
                          <BsArrowClockwise
                            size={24}
                            style={{
                              color: '#B45309',
                              animation: 'spin 1s linear infinite',
                              marginBottom: '12px',
                            }}
                          />
                          <p
                            style={{
                              color: '#6b7280',
                              fontSize: '14px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              margin: 0,
                            }}
                          >
                            {loadingTransportRefresh
                              ? 'Refreshing...'
                              : 'Loading assigned transport...'}
                          </p>
                        </div>
                      ) : assignedTransportError ? (
                        <div
                          className="text-center py-4"
                          style={{
                            backgroundColor: '#FEF2F2',
                            borderRadius: '8px',
                            padding: '32px',
                            border: '1px solid #FECACA',
                          }}
                        >
                          <FaExclamationCircle
                            size={28}
                            style={{ color: '#DC2626', marginBottom: '12px' }}
                          />
                          <p
                            style={{
                              color: '#991B1B',
                              fontSize: '14px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              margin: 0,
                              fontWeight: 600,
                            }}
                          >
                            {assignedTransportError}
                          </p>
                        </div>
                      ) : assignedTransports.length > 0 ? (
                        <Row className="g-3 text-start">
                          {assignedTransports.map((t) => (
                            <Col xs={12} md={6} key={t.id}>
                              <div
                                style={{
                                  backgroundColor: '#ffffff',
                                  borderRadius: '8px',
                                  padding: '14px 16px',
                                  border: '1px solid #E5E7EB',
                                  transition: 'all 0.2s ease',
                                  height: '100%',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#FFFBEB'
                                  e.currentTarget.style.borderColor = '#B45309'
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(180, 83, 9, 0.12)'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = '#ffffff'
                                  e.currentTarget.style.borderColor = '#E5E7EB'
                                  e.currentTarget.style.boxShadow = 'none'
                                }}
                              >
                                <div className="d-flex align-items-start gap-3">
                                  <div
                                    style={{
                                      width: '40px',
                                      height: '40px',
                                      borderRadius: '10px',
                                      backgroundColor: '#FFEDD5',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      flexShrink: 0,
                                    }}
                                  >
                                    <FaBus size={18} style={{ color: '#B45309' }} />
                                  </div>
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#111827',
                                        fontFamily: 'Inter, system-ui, sans-serif',
                                        marginBottom: '6px',
                                      }}
                                    >
                                      Vehicle No.:{' '}
                                      {t.bus_number || (t.bus_id ? `#${t.bus_id}` : '-')}
                                    </div>
                                    <div
                                      className="d-flex flex-wrap align-items-center gap-2"
                                      style={{ fontSize: '13px', color: '#6b7280' }}
                                    >
                                      <span
                                        style={{
                                          fontWeight: '600',
                                          color: '#374151',
                                          fontFamily: 'Inter, system-ui, sans-serif',
                                        }}
                                      >
                                        Driver Contact Number:{' '}
                                        {t.driver_contact_number || '-'}
                                      </span>
                                      {t.driver_name ? (
                                        <>
                                          <span style={{ color: '#D1D5DB' }}>|</span>
                                          <span style={{ color: '#374151', fontWeight: '500' }}>
                                            Driver Name: {t.driver_name}
                                          </span>
                                        </>
                                      ) : null}
                                    </div>
                                    {t.pickup ? (
                                      <div
                                        style={{
                                          marginTop: '8px',
                                          fontSize: '13px',
                                          color: '#374151',
                                          fontFamily: 'Inter, system-ui, sans-serif',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        <span style={{ fontWeight: '600' }}>Pick up: </span>
                                        {t.pickup}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      ) : (
                        <div
                          style={{
                            backgroundColor: '#F9FAFB',
                            borderRadius: '8px',
                            padding: '32px',
                            textAlign: 'center',
                            border: '1px dashed #D1D3D4',
                          }}
                        >
                          <div
                            style={{
                              width: '64px',
                              height: '64px',
                              borderRadius: '50%',
                              backgroundColor: '#E5E7EB',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginBottom: '16px',
                            }}
                          >
                            <FaBus size={28} style={{ color: '#9ca3af' }} />
                          </div>
                          <p
                            style={{
                              margin: 0,
                              color: '#111827',
                              fontSize: '15px',
                              fontWeight: '600',
                              fontFamily: 'Inter, system-ui, sans-serif',
                              marginBottom: '4px',
                            }}
                          >
                            No transport assigned yet
                          </p>
                          <p
                            style={{
                              margin: 0,
                              color: '#6b7280',
                              fontSize: '13px',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            This student has no assigned transport yet.
                          </p>
                        </div>
                      )}
                    </div>
                  </Card.Body>
                )}
              </Card>
            </Container>
          </>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '50vh' }}
          >
            <p
              style={{
                color: '#6b7280',
                fontSize: '16px',
                fontFamily: 'Inter, system-ui, sans-serif',
              }}
            >
              Loading student data...
            </p>
          </div>
        )}
      </div>
      <Modal
        centered
        show={opentDateModal}
        onHide={() => setOpenDateModal(false)}
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="bg-danger text-white">
          <Modal.Title>Select Leaving Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Select Date</Form.Label>
              <Form.Control
                type="date"
                name="leaving_date"
                value={leavingDate}
                onChange={(e) => setLeavingDate(e.target.value)}
              />
            </Form.Group>
          </Form>
          <Modal.Footer>
            <Button
              variant="outline-secondary"
              onClick={() => setOpenDateModal(false)}
            >
              Close
            </Button>
            <Button variant="outline-danger" onClick={handleDischargeNow}>
              Leave Now
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ViewStudent
